module.exports = __webpack_public_path__ + "static/media/SAG-AFTRA Logo.9e06ea10.jpeg";